import { type UseQueryResult } from '@tanstack/react-query';
import { z } from 'zod';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';
import { gatewayDetail, gatewayRow, type GatewayDetail, type GatewayRow } from './schemas.js';
import { gatewayEndpoints } from './endpoints.js';

const gatewayList = z.array(gatewayRow);

/**
 * One gateway by id.
 *
 * Disabled while the id is empty so a create screen can mount the hook without
 * issuing a detail request.
 */
export function useGateway(gatewayId: string): UseQueryResult<GatewayDetail> {
  return useApiQuery<typeof gatewayDetail>({
    queryKey: queryKeys.notificationGateways.detail(gatewayId),
    path: gatewayEndpoints.detail(gatewayId),
    schema: gatewayDetail,
    enabled: gatewayId !== '',
  });
}

/** All gateways, optionally filtered to one channel. */
export function useGateways(channel: string | undefined): UseQueryResult<readonly GatewayRow[]> {
  return useApiQuery<typeof gatewayList>({
    queryKey: queryKeys.notificationGateways.list({
      scope: { channel: channel ?? '' },
    }),
    path: gatewayEndpoints.list,
    schema: gatewayList,
    query: channel === undefined || channel === '' ? {} : { channel },
  });
}
